module.exports = __webpack_public_path__ + "img/icon-warning-snøskred-3.211dba75.svg";